/* eslint-disable camelcase */
import { call, put, select, race, take, cancelled, fork, all, takeLatest, takeEvery } from 'redux-saga/effects'
import { selectUser } from './user'
import axios from 'axios'
import API from '../config'
import { Record } from 'immutable'
import { unionBy, get, uniqBy } from 'lodash-es'
import { normalize } from 'normalizr'
import history from '../history'

import { RECEIVE_UPDATED_POST } from './card'
import { REQUEST_ACCOUNT_PICKS, RECEIVE_ACCOUNT_PICKS } from './pick'
import {
  RECEIVE_ADD_FEED_TO_SECTIONS_PROFILE,
  RECEIVE_REMOVE_FEED_FROM_SECTIONS_PROFILE,
  RECEIVE_FEEDS_SAVED_TO_SECTIONS_PROFILE,
  RECEIVE_ADD_FEED_TO_SECTIONS_FEEDER,
  RECEIVE_REMOVE_FEED_FROM_SECTIONS_FEEDER,
  RECEIVE_FEEDS_SAVED_TO_SECTIONS_FEEDER,
  UPDATE_SORT_FEEDS_SECTIONS_PROFILE,
  RECEIVE_CUSTOM_FEED_SECTIONS,
  RECEIVE_UPDATE_SORT_CUSTOM_FEED_SECTIONS,
  RECEIVE_RETRIEVE_IMAGE_FIRST_ITEM,
  RECEIVE_UPDATE_SORT_CUSTOM_FEED_SECTION,
  RECEIVE_ADD_FEED_TO_FEED_SECTION,
  RECEIVE_REMOVE_FEED_FROM_FEED_SECTION
} from './feeds'
import { user as userSchema, feed as feedSchema } from '../schemas'
import { selectTags, requestAddTag } from './tags'
import { OPEN_MOD } from './mods'

import { receiveProfile } from './profile'
import { getHeaders } from './api'

// ------------------------------------
// Constants
// ------------------------------------
const rootApi = `${API.apiPath}/${API.apiVersion}/`

export const RESET_CONTENT = 'RESET_CONTENT'

export const REQUEST_ALL_USER_CONTENT = 'REQUEST_ALL_USER_CONTENT'

export const REQUEST_CUSTOM_FEEDS = 'REQUEST_CUSTOM_FEEDS'
export const RECEIVE_CUSTOM_FEEDS = 'RECEIVE_CUSTOM_FEEDS'

export const REQUEST_PICKED_FEEDS = 'REQUEST_PICKED_FEEDS'
export const RECEIVE_PICKED_FEEDS = 'RECEIVE_PICKED_FEEDS'

export const REQUEST_SAVED_FEEDS = 'REQUEST_SAVED_FEEDS'
export const RECEIVE_SAVED_FEEDS = 'RECEIVE_SAVED_FEEDS'

export const REQUEST_PROFILE_HOME_CONTENT = 'REQUEST_PROFILE_HOME_CONTENT'
export const RECEIVE_PROFILE_HOME_CONTENT = 'RECEIVE_PROFILE_HOME_CONTENT'

export const REQUEST_COLLECTIONS = 'REQUEST_COLLECTIONS'
export const RECEIVE_COLLECTIONS = 'RECEIVE_COLLECTIONS'

export const REQUEST_SAVED = 'REQUEST_SAVED'
export const RECEIVE_SAVED = 'RECEIVE_SAVED'

export const REQUEST_PINS = 'REQUEST_PINS'
export const RECEIVE_PINNED_COLLECTIONS = 'RECEIVE_PINNED_COLLECTIONS'
export const RECEIVE_PINNED_PICKS = 'RECEIVE_PINNED_PICKS'
export const RECEIVE_ALL_PINS = 'RECEIVE_ALL_PINS'

const REQUEST_PIN_PICK = 'REQUEST_PIN_PICK'
export const PIN_PICK_SUCCESS = 'PIN_PICK_SUCCESS'
const REQUEST_UNPIN_PICK = 'REQUEST_UNPIN_PICK'
export const UNPIN_PICK_SUCCESS = 'UNPIN_PICK_SUCCESS'

const TO_EDIT_PINS_MODE = 'TO_EDIT_PINS_MODE'
export const TO_VIEW_MODE = 'TO_VIEW_MODE'
export const UPDATE_PINS_ORDER = 'UPDATE_PINS_ORDER'
const REQUEST_SAVE_PINS_ORDER = 'REQUEST_SAVE_PINS_ORDER'
const REQUEST_SAVE_ALL_PINS_ORDER = 'REQUEST_SAVE_ALL_PINS_ORDER'
export const PINS_ORDER_SAVED = 'PINS_ORDER_SAVED'

const TO_ADD_TO_COLLECTION_MODE = 'TO_ADD_TO_COLLECTION_MODE'
export const REQUEST_ADD_TO_COLLECTION = 'REQUEST_ADD_TO_COLLECTION'
export const RECEIVE_ADD_TO_COLLECTION = 'RECEIVE_ADD_TO_COLLECTION'
const REQUEST_UNLINK_FROM_COLLECTION = 'REQUEST_UNLINK_FROM_COLLECTION'
export const CARD_UNLINKED = 'CARD_UNLINKED'

const REQUEST_FOLLOWERS = 'REQUEST_FOLLOWERS'
export const RECEIVE_FOLLOWERS = 'RECEIVE_FOLLOWERS'

export const RECEIVE_USERS = 'RECEIVE_USERS'
const REQUEST_USERS = 'REQUEST_USERS'

export const CLEAR_USER_COLLECTIONS = 'CLEAR_USER_COLLECTIONS'

// ------------------------------------
// Actions
// ------------------------------------
export const requestCustomFeeds = payload => {
  return {
    type: REQUEST_CUSTOM_FEEDS,
    payload
  }
}

export const requestSavedFeeds = payload => {
  return {
    type: REQUEST_SAVED_FEEDS,
    payload
  }
}

export const requestPickedFeeds = payload => ({
  type: REQUEST_PICKED_FEEDS,
  payload
})

export const receiveCustomFeeds = data => {
  return {
    type: RECEIVE_CUSTOM_FEEDS,
    payload: {
      data
    }
  }
}

export const receiveSavedFeeds = data => {
  return {
    type: RECEIVE_SAVED_FEEDS,
    payload: {
      data
    }
  }
}

export const receivePickedFeeds = data => ({
  type: RECEIVE_PICKED_FEEDS,
  payload: {
    data
  }
})

export const requestProfileHomeContent = payload => ({
  type: REQUEST_PROFILE_HOME_CONTENT,
  payload
})

const receiveProfileHomeContent = data => ({
  type: RECEIVE_PROFILE_HOME_CONTENT,
  payload: { data }
})

export const resetContent = () => dispatch => {
  dispatch({
    type: RESET_CONTENT
  })
  return Promise.resolve()
}

export function resetContentPlainObject(payload) {
  return { type: RESET_CONTENT, payload }
}

export function requestCollections(payload) {
  return { type: REQUEST_COLLECTIONS, payload }
}

export function receiveCollections(data) {
  return { type: RECEIVE_COLLECTIONS, payload: { data } }
}

export function requestSaved(payload) {
  return { type: REQUEST_SAVED, payload }
}

export function receiveSaved(data) {
  return { type: RECEIVE_SAVED, payload: { data } }
}

export function requestPinPick(payload) {
  return {
    type: REQUEST_PIN_PICK,
    payload
  }
}

function pinPickSuccess(payload) {
  return {
    type: PIN_PICK_SUCCESS,
    payload
  }
}

export function requestUnpinPick(payload) {
  return {
    type: REQUEST_UNPIN_PICK,
    payload
  }
}

function unpinPickSuccess(payload) {
  return {
    type: UNPIN_PICK_SUCCESS,
    payload
  }
}

export function toEditPinsMode(payload) {
  return {
    type: TO_EDIT_PINS_MODE,
    payload
  }
}

export function toViewMode(payload) {
  return {
    type: TO_VIEW_MODE
  }
}

export function updatePinsOrder(payload) {
  return {
    type: UPDATE_PINS_ORDER,
    payload
  }
}

export function requestSavePinsOrder(payload) {
  return {
    type: REQUEST_SAVE_PINS_ORDER,
    payload
  }
}

function pinsOrderSaved(payload) {
  return {
    type: PINS_ORDER_SAVED,
    payload
  }
}

export function requestSaveAllPinsOrder(payload) {
  return {
    type: REQUEST_SAVE_ALL_PINS_ORDER,
    payload
  }
}

export function toAddToCollectionMode(payload) {
  return {
    type: TO_ADD_TO_COLLECTION_MODE,
    payload
  }
}

export function requestAddToCollection(payload) {
  return {
    type: REQUEST_ADD_TO_COLLECTION,
    payload
  }
}

export function receiveAddedToCollection(payload) {
  return {
    type: RECEIVE_ADD_TO_COLLECTION,
    payload
  }
}

export function requestUnlinkFromCollection(payload) {
  return {
    type: REQUEST_UNLINK_FROM_COLLECTION,
    payload
  }
}

function cardUnlinked(payload) {
  return {
    type: CARD_UNLINKED,
    payload
  }
}

export function requestAllUserContent(payload = {}) {
  return {
    type: REQUEST_ALL_USER_CONTENT,
    payload
  }
}

export function requestFollowers(payload) {
  return {
    type: REQUEST_FOLLOWERS,
    payload
  }
}

function receiveFollowers(payload) {
  return {
    type: RECEIVE_FOLLOWERS,
    payload
  }
}

export function clearUserCollections(id) {
  return {
    type: CLEAR_USER_COLLECTIONS,
    payload: id
  }
}

function* getCustomFeeds(action) {
  const url = rootApi + `account/get-custom-feeds`
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()

  const { userId: user_id, home = 0 } = action.payload

  try {
    const response = yield call([axios, 'get'], url, {
      headers: getHeaders(token),
      params: { user_id, home },
      cancelToken: source.token
    })
    if (get(response, 'status') === 200) {
      let normalizedData
      const { feeds } = response.data

      if (user_id) {
        normalizedData = normalize({ id: user_id, feeds }, userSchema)
      } else {
        feeds.forEach(i => {
          i.home = true
        })
        normalizedData = normalize(feeds, [feedSchema])
      }
      yield put(receiveCustomFeeds(normalizedData))
    }
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      source.cancel()
    }
  }
}

function* getSavedFeeds(action) {
  const url = rootApi + `custom-feed/saves`
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()

  const { userId: user_id, home = 0 } = action.payload

  try {
    const response = yield call([axios, 'get'], url, {
      headers: getHeaders(token),
      params: { user_id, home },
      cancelToken: source.token
    })

    if (get(response, 'status') === 200) {
      let normalizedData
      const feeds = response.data.saved_feeds

      if (user_id) {
        normalizedData = normalize({ id: user_id, feeds }, userSchema)
      } else {
        feeds.forEach(i => {
          i.home = true
        })
        normalizedData = normalize(feeds, [feedSchema])
      }
      yield put(receiveSavedFeeds(normalizedData))
    }
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      source.cancel()
    }
  }
}

function* getPickedFeeds(action) {
  const url = rootApi + `custom-feed/picks`
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()

  const { userId: user_id, home = 0 } = action.payload

  try {
    const response = yield call([axios, 'get'], url, {
      headers: getHeaders(token),
      params: { user_id, home },
      cancelToken: source.token
    })
    if (get(response, 'status') === 200) {
      let normalizedData
      const feeds = response.data.picked_feeds

      if (user_id) {
        normalizedData = normalize({ id: user_id, feeds }, userSchema)
      } else {
        feeds.forEach(i => {
          i.home = true
        })
        normalizedData = normalize(feeds, [feedSchema])
      }
      yield put(receivePickedFeeds(normalizedData))
    }
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      source.cancel()
    }
  }
}

function* getHomeTabContent(action) {
  const url = rootApi + `account/profile-home-feed`
  const tags = action.payload.withoutTags ? [] : yield select(selectTags)
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  const { maxId, refId } = action.payload
  const id = action.payload.id || get(user, 'data.user.id')
  try {
    const user_id = id
    const headers = getHeaders(token)
    const params = Object.assign(
      { limit: 21 },
      user_id && { user_id, referrer_id: refId || user_id },
      maxId && { max_id: maxId },
      tags.length > 0 && { tags: tags.join(',') }
    )
    const response = yield call([axios, 'get'], url, {
      params,
      headers,
      cancelToken: source.token
    })

    const homeTabContent = response.data.all_decks
    const normalizedData = normalize({ id, homeTabContent }, userSchema)
    yield put(receiveProfileHomeContent(normalizedData))
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      source.cancel()
    }
  }
}

function* getCollections(action) {
  const url = rootApi + `deck/get_collections`
  const tags = action.payload.withoutTags ? [] : yield select(selectTags)
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  let { maxId, limit, newCardId, keyword } = action.payload
  limit = limit || 21
  const id = action.payload.id || get(user, 'data.user.id')
  const collectionThumbnails = action.payload.collectionThumbnails || 'squared'

  try {
    const user_id = id
    const headers = getHeaders(token)
    const params = Object.assign(
      { published: 1, limit },
      user_id && { user_id },
      { referrer_id: id },
      maxId && { max_id: maxId },
      tags.length > 0 && { tags: tags.join(',') },
      { collection_thumbnails: collectionThumbnails, new_card_id: newCardId },
      keyword && { keyword }
    )
    const response = yield call([axios, 'get'], url, {
      params,
      headers,
      cancelToken: source.token
    })

    const { all_decks } = response.data
    const structuredResponse = { arr: all_decks, end: all_decks.length < limit }
    const collections = {}
    collections.public = structuredResponse
    const normalizedData = normalize({ id, collections }, userSchema)
    yield put(receiveCollections(normalizedData))
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      source.cancel()
    }
  }
}

export function requestPins(payload) {
  return { type: REQUEST_PINS, payload }
}

function receivePinnedCollections(data) {
  return { type: RECEIVE_PINNED_COLLECTIONS, payload: { data } }
}

function receivePinnedPicks(data) {
  return { type: RECEIVE_PINNED_PICKS, payload: { data } }
}

function receiveAllPins(data) {
  return { type: RECEIVE_ALL_PINS, payload: { data } }
}

function* getPins(action) {
  const url = rootApi + `account/get-pins`
  const user = yield select(selectUser)
  const tags = action.payload.withoutTags ? [] : yield select(selectTags)
  const token = get(user, 'data.auth_token')
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  const { feed, collectionThumbnails = 'squared', start, limit = 10 } = action.payload
  const id = action.payload.id || get(user, 'data.user.id')

  try {
    const user_id = id
    let all_decks, pins, allPins
    const headers = getHeaders(token)
    if (feed) {
      const params = Object.assign(
        user_id && { user_id },
        { referrer_id: id },
        { feed },
        tags.length > 0 && { tags: tags.join(',') },
        {
          collection_thumbnails: collectionThumbnails
        }
      )
      const response = yield call([axios, 'get'], url, {
        params,
        headers,
        cancelToken: source.token
      })

      all_decks = response.data.pins
      pins = { arr: all_decks, end: all_decks.length < limit }
    } else {
      const params = Object.assign(
        user_id && { user_id },
        start && { start },
        tags.length > 0 && { tags: tags.join(',') },
        {
          collection_thumbnails: collectionThumbnails,
          limit
        }
      )
      allPins = yield call([axios, 'get'], url, {
        params,
        headers,
        cancelToken: source.token
      })
    }
    if (feed === 'collections') {
      const normalizedData = normalize({ id, pinnedCollections: pins }, userSchema)
      yield put(receivePinnedCollections(normalizedData))
    } else if (feed === 'picks') {
      const normalizedData = normalize({ id, pinnedPicks: pins }, userSchema)
      yield put(receivePinnedPicks(normalizedData))
    } else {
      const allPinsData = normalize({ id, allPinnedItems: allPins.data.pins }, userSchema)
      yield put(receiveAllPins(allPinsData))
    }
  } catch (e) {
  } finally {
    if (yield cancelled()) {
      source.cancel()
    }
  }
}

function* pinPick(action) {
  const url = `${rootApi}account/create-pin`
  const { cardId, feed } = action.payload
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const postParams = {
    card_id: cardId,
    feed
  }
  try {
    yield call([axios, 'post'], url, postParams, {
      headers: getHeaders(token)
    })
    yield put(pinPickSuccess({ cardId, feed, userId: user.data.user.id }))
  } catch (e) {
  } finally {
  }
}

function* unpinPick(action) {
  const url = `${rootApi}account/remove-pin`
  const { cardId, feed } = action.payload
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const postParams = {
    card_id: cardId,
    feed
  }
  try {
    yield call([axios, 'post'], url, postParams, {
      headers: getHeaders(token)
    })
    yield put(unpinPickSuccess({ cardId, feed, userId: user.data.user.id }))
  } catch (e) {
  } finally {
  }
}

function* savePinsOrder(action) {
  const url = `${rootApi}account/change-pin-order`
  const { picks, collections, previousURL, previousTags } = action.payload
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const picksParams = {
    order: picks,
    feed: 'picks'
  }
  const collectionsParams = {
    order: collections,
    feed: 'collections'
  }
  try {
    yield all([
      call([axios, 'post'], url, picksParams, {
        headers: getHeaders(token)
      }),
      call([axios, 'post'], url, collectionsParams, {
        headers: getHeaders(token)
      })
    ])
    yield put(requestAddTag(previousTags))
    yield put(toViewMode())
    history.push(previousURL)
  } catch (e) {
  } finally {
  }
}

function* saveAllPinsOrder(action) {
  const url = `${rootApi}account/change-pin-order`
  const { cardIds } = action.payload
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  try {
    yield call(
      [axios, 'post'],
      url,
      { order: cardIds },
      {
        headers: getHeaders(token)
      }
    )
    yield put(pinsOrderSaved({ userId: user.data.user.id, cardIds }))
  } catch (e) {
  } finally {
  }
}

function* addToCollection(action) {
  const url = `${rootApi}deck/link_cards`
  const { pickId, collectionId } = action.payload
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const postParams = {
    card_ids: [pickId],
    link_to: collectionId
  }
  try {
    const response = yield call([axios, 'post'], url, postParams, {
      headers: getHeaders(token)
    })
    yield put(receiveAddedToCollection({ collectionId: collectionId, added: response.data.result === 'success' }))
  } catch (e) {
  } finally {
  }
}

function* getFollowers(action) {
  const { id, isFollowings, maxId } = action.payload.params
  const url = `${rootApi}account/${isFollowings ? 'get_followings' : 'get_followers'}`
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const headers = getHeaders(token)
  const getParams = {
    user_id: id,
    max_id: maxId
  }
  try {
    const response = yield call([axios, 'get'], url, {
      params: getParams,
      headers
    })
    const normalizedData = normalize(response.data[isFollowings ? 'followings' : 'followers'], [userSchema])
    yield put(receiveProfile(normalizedData))
    yield put(receiveFollowers({ id, data: normalizedData, isFollowings }))
  } catch (e) {
  } finally {
  }
}

function* getSaved(action) {
  const url = `${rootApi}account/get-my-saves`
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const { length = 0 } = action.payload
  const getParams = {
    start: length,
    limit: length + 10
  }
  try {
    const response = yield call([axios, 'get'], url, {
      params: getParams,
      headers: getHeaders(token)
    })
    const savedCards = response.data.saved_cards
    const normalizedData = normalize({ id: user.data.user.id, savedCards }, userSchema)

    yield put(receiveSaved(normalizedData))
  } catch (e) {
  } finally {
  }
}

function* getHomeFeedContentSaga() {
  yield takeLatest(REQUEST_PROFILE_HOME_CONTENT, getHomeTabContent)
}

function* getCollectionsSaga() {
  while (true) {
    const action = yield take([REQUEST_COLLECTIONS, TO_ADD_TO_COLLECTION_MODE, REQUEST_ALL_USER_CONTENT])
    yield race({
      task: call(getCollections, action),
      cancel: take('LOCATION_CHANGE')
    })
  }
}

function* getSavedSaga() {
  while (true) {
    const action = yield take([REQUEST_SAVED, TO_ADD_TO_COLLECTION_MODE, REQUEST_ALL_USER_CONTENT])
    yield race({
      task: call(getSaved, action),
      cancel: take('LOCATION_CHANGE')
    })
  }
}

function* getPinsSaga() {
  while (true) {
    const action = yield take([REQUEST_PINS, TO_ADD_TO_COLLECTION_MODE, TO_EDIT_PINS_MODE, REQUEST_ALL_USER_CONTENT])
    yield race({
      task: fork(getPins, action),
      cancel: take('LOCATION_CHANGE')
    })
  }
}

function* getCustomFeedsSaga() {
  yield takeLatest(REQUEST_CUSTOM_FEEDS, getCustomFeeds)
}

function* getSavedFeedsSaga() {
  yield takeLatest(REQUEST_SAVED_FEEDS, getSavedFeeds)
}

function* getPickedFeedsSaga() {
  yield takeLatest(REQUEST_PICKED_FEEDS, getPickedFeeds)
}

function* pinPickSaga() {
  while (true) {
    const action = yield take(REQUEST_PIN_PICK)
    yield call(pinPick, action)
  }
}

function* unpinPickSaga() {
  while (true) {
    const action = yield take(REQUEST_UNPIN_PICK)
    yield call(unpinPick, action)
  }
}

function* savePinsOrderSaga() {
  while (true) {
    const action = yield take(REQUEST_SAVE_PINS_ORDER)
    yield call(savePinsOrder, action)
  }
}

function* saveAllPinsOrderSaga() {
  while (true) {
    const action = yield take(REQUEST_SAVE_ALL_PINS_ORDER)
    yield call(saveAllPinsOrder, action)
  }
}

function* addToCollectionSaga() {
  yield takeEvery(REQUEST_ADD_TO_COLLECTION, addToCollection)
}

function* getFollowersSaga() {
  while (true) {
    const action = yield take([OPEN_MOD, REQUEST_FOLLOWERS])
    if (get(action, 'payload.type') === 'followers' || action.type === REQUEST_FOLLOWERS) {
      yield call(getFollowers, action)
    }
  }
}

const receiveUsers = payload => {
  return {
    type: RECEIVE_USERS,
    payload
  }
}

function* processUsersSearch(action) {
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  if (token) {
    try {
      const response = yield call([axios, 'get'], `${rootApi}account/public_search?type=users`, {
        cancelToken: source.token,
        headers: getHeaders(token)
      })
      if (get(response, 'status') === 200) {
        const normalizedUsers = normalize(response.data.hits, [userSchema])
        yield put(receiveUsers({ data: normalizedUsers }))
      }
    } catch (e) {
    } finally {
      if (yield cancelled()) {
        source.cancel()
      }
    }
  }
}

function* unlinkFromCollection(action) {
  const user = yield select(selectUser)
  const token = get(user, 'data.auth_token')
  const { collectionId, cardId } = action.payload
  if (token) {
    try {
      yield call(
        [axios, 'post'],
        `${rootApi}deck/unlink_card_from_collection`,
        {
          deck_id: collectionId,
          card_id: cardId
        },
        {
          headers: getHeaders(token)
        }
      )
      yield put(cardUnlinked({ collectionId, cardId }))
    } catch (e) {
    } finally {
    }
  }
}

export function requestUsers(payload) {
  return {
    type: REQUEST_USERS,
    payload
  }
}

function* getUsersSaga() {
  while (true) {
    const action = yield take(REQUEST_USERS)
    yield call(processUsersSearch, action)
  }
}

function* unlinkSaga() {
  yield takeEvery(REQUEST_UNLINK_FROM_COLLECTION, unlinkFromCollection)
}

export const sagas = [
  getHomeFeedContentSaga,
  getCollectionsSaga,
  getSavedSaga,
  getPinsSaga,
  getCustomFeedsSaga,
  getPickedFeedsSaga,
  getSavedFeedsSaga,
  pinPickSaga,
  unpinPickSaga,
  savePinsOrderSaga,
  saveAllPinsOrderSaga,
  addToCollectionSaga,
  getFollowersSaga,
  getUsersSaga,
  unlinkSaga
]

// ------------------------------------
// Reducer
/* ------------------------------------ */

const CollectionFactory = Record({
  all_decks: [],
  end: false
})

const initialState = {
  collections: new CollectionFactory(),
  pinnedCollections: new CollectionFactory(),
  pinnedPicks: new CollectionFactory(),
  pinnedFeeds: new CollectionFactory(),
  savedFeeds: new CollectionFactory(),
  isInEditPinsMode: null,
  isInAddToCollectionMode: null,
  pinnedCollectionsFetching: false,
  pinnedPicksFetching: false,
  picksFetching: false,
  collectionsFetching: false,
  savedFetching: false,
  customFeedSections: [],
  feedsInSectionsProfile: [],
  feedsInSectionsFeeder: []
}

export default function(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_ADD_FEED_TO_FEED_SECTION: {
      const incomingFeedSection = action.payload.data.feed_section
      const newFeedsSections = state.customFeedSections
        .filter(item => item.id !== incomingFeedSection.id)
        .concat([incomingFeedSection])
        .sort((a, b) => a.position - b.position)
      return {
        ...state,
        customFeedSections: newFeedsSections
      }
    }
    case RECEIVE_REMOVE_FEED_FROM_FEED_SECTION: {
      const incomingFeedSection = action.payload.data.feed_section
      const newFeedsSections = state.customFeedSections
        .filter(item => item.id !== incomingFeedSection.id)
        .concat([incomingFeedSection])
        .sort((a, b) => a.position - b.position)
      return {
        ...state,
        customFeedSections: newFeedsSections
      }
    }
    case RECEIVE_RETRIEVE_IMAGE_FIRST_ITEM: {
      const transformedCustomFeedSections = state.customFeedSections.map(item => {
        item.feeds.map(feed => {
          if (feed.id === action.payload.id) {
            feed.thumbnail = action.payload.thumbnail
          }
        })
      })
      return {
        ...state,
        transformedCustomFeedSections
      }
    }
    case RECEIVE_CUSTOM_FEED_SECTIONS: {
      return {
        ...state,
        customFeedSections: action.payload.sort((a, b) => a.position - b.position)
      }
    }
    case RECEIVE_UPDATE_SORT_CUSTOM_FEED_SECTION: {
      const feedIndex = state.customFeedSections.findIndex(item => item.id === action.payload.feed.id)
      const feeds = state.customFeedSections[feedIndex].feeds
      const element = feeds[action.payload.oldIndex]
      feeds.splice(action.payload.oldIndex, 1)
      feeds.splice(action.payload.newIndex, 0, element)
      feeds.map((item, index) => (item.position = index))
      state.customFeedSections[feedIndex].feeds = feeds
      return {
        ...state,
        customFeedSections: state.customFeedSections
      }
    }
    case RECEIVE_UPDATE_SORT_CUSTOM_FEED_SECTIONS: {
      const items = state.customFeedSections
      const element = items[action.payload.payload.oldIndex]
      items.splice(action.payload.payload.oldIndex, 1)
      items.splice(action.payload.payload.newIndex, 0, element)
      items.map((item, index) => (item.position = index))
      return {
        ...state,
        customFeedSections: items
      }
    }
    case UPDATE_SORT_FEEDS_SECTIONS_PROFILE: {
      const items = state.feedsInSectionsProfile
      const element = items[action.payload.oldIndex]
      items.splice(action.payload.oldIndex, 1)
      items.splice(action.payload.newIndex, 0, element)
      items.map((item, index) => (item.position = index))
      return {
        ...state,
        feedsInSectionsProfile: items
      }
    }
    case RECEIVE_FEEDS_SAVED_TO_SECTIONS_FEEDER:
      return {
        ...state,
        feedsInSectionsFeeder: uniqBy(state.feedsInSectionsFeeder.concat(action.payload), 'id')
      }
    case RECEIVE_ADD_FEED_TO_SECTIONS_FEEDER:
      const itemFeeder = {
        to: '/custom-feed/' + action.payload.get('id') + '----' + action.payload.get('name'),
        text: action.payload.get('name'),
        id: action.payload.get('id')
      }
      return {
        ...state,
        feedsInSectionsFeeder: [itemFeeder].concat(state.feedsInSectionsFeeder)
      }
    case RECEIVE_REMOVE_FEED_FROM_SECTIONS_FEEDER:
      return {
        ...state,
        feedsInSectionsFeeder: state.feedsInSectionsFeeder.filter(item => {
          return item.id !== action.payload.get('id')
        })
      }
    case RECEIVE_FEEDS_SAVED_TO_SECTIONS_PROFILE:
      return {
        ...state,
        feedsInSectionsProfile: uniqBy(state.feedsInSectionsProfile.concat(action.payload), 'id')
      }
    case RECEIVE_ADD_FEED_TO_SECTIONS_PROFILE:
      const itemProfile = {
        to: '/custom-feed/' + action.payload.get('id') + '----' + action.payload.get('name'),
        text: action.payload.get('name'),
        id: action.payload.get('id')
      }
      return {
        ...state,
        feedsInSectionsProfile: [itemProfile].concat(state.feedsInSectionsProfile)
      }
    case RECEIVE_REMOVE_FEED_FROM_SECTIONS_PROFILE:
      return {
        ...state,
        feedsInSectionsProfile: state.feedsInSectionsProfile.filter(item => {
          return item.id !== action.payload.get('id')
        })
      }
    case REQUEST_PINS: {
      return {
        ...state,
        [action.payload.feed === 'picks' ? 'pinnedPicksFetching' : 'pinnedCollectionsFetching']: true
      }
    }
    case REQUEST_COLLECTIONS:
      return {
        ...state,
        collectionsFetching: true
      }
    case RECEIVE_PINNED_PICKS:
      return {
        ...state,
        pinnedPicksFetching: false
      }
    case RECEIVE_PINNED_COLLECTIONS:
      return {
        ...state,
        pinnedCollectionsFetching: false
      }
    case RECEIVE_COLLECTIONS:
      return {
        ...state,
        collectionsFetching: false
      }
    case REQUEST_ACCOUNT_PICKS:
      return {
        ...state,
        picksFetching: true
      }
    case RECEIVE_ACCOUNT_PICKS:
      return {
        ...state,
        picksFetching: false
      }
    case REQUEST_SAVED:
      return {
        ...state,
        savedFetching: true
      }
    case RECEIVE_SAVED:
      return {
        ...state,
        savedFetching: false
      }
    case RECEIVE_UPDATED_POST: {
      const currentDecks = state.collections.all_decks
      const updatedPost = action.payload

      if (currentDecks.filter(i => i.id === updatedPost.id).length > 0) {
        return {
          ...state,
          collections: state.collections
            .set('all_decks', unionBy(currentDecks.all_decks, action.payload, 'id'))
            .set('end', action.payload.end)
        }
      } else {
        return state
      }
    }
    case RESET_CONTENT:
      return initialState
    case TO_EDIT_PINS_MODE:
      return {
        ...state,
        isInEditPinsMode: action.payload.pathname
      }
    case TO_VIEW_MODE:
      return {
        ...state,
        isInEditPinsMode: null,
        isInAddToCollectionMode: null
      }
    case TO_ADD_TO_COLLECTION_MODE:
      return {
        ...state,
        isInAddToCollectionMode: action.payload.itemId
      }

    default:
      return state
  }
}
